export default  class SliderInput extends Phaser.GameObjects.Container {
    _value: number | string;
    label: any;
    margin: number;
    sliderLength: any;
    sliderX: any;
    sliderY: number;
    dotSize: number;
    sliderLine: any;
    hover: any;
    sliderPoint: any;
    onChange: (number: number) => void;

    constructor(scene, x, y, text, style){
        super(scene);
        this.x = x;
        this.y = y;

        this.label = scene.add.text(0,0,text,style);
        this.margin = 60;
        this.sliderLength = 250;

        this.width = this.label.width + this.margin + this.sliderLength;
        this.height = this.label.height;

        this.sliderX = this.label.width + this.margin;
        this.sliderY = this.label.height/2;

        this.dotSize = 20;

        this.sliderLine = scene.add.graphics();
        this.sliderLine.lineStyle(2,0xFFFFFF, 1);
        this.sliderLine.lineBetween(this.sliderX, this.sliderY, this.sliderX + this.sliderLength , this.sliderY);

        this.hover = scene.add.text(0,0);
        this.hover.setSize(this.width, this.height);
        this.hover.setInteractive();
        this.hover.input.cursor = "pointer";

        this.sliderPoint = scene.add.graphics();
        const pointRect = new Phaser.Geom.Rectangle(this.sliderX - this.dotSize, this.sliderY - this.dotSize, this.dotSize*2, this.dotSize*2);
        this.sliderPoint.setInteractive(pointRect, Phaser.Geom.Rectangle.Contains);
        this.sliderPoint.fillStyle(0xFFFFFF, 1);
        this.sliderPoint.fillRectShape(pointRect);
        this.sliderPoint.input.cursor = "pointer";

        scene.input.setDraggable(this.sliderPoint);

        scene.input.on('drag', (pointer, gameObject, dragX, dragY) => {
            if(gameObject !== this.sliderPoint) return;
            if(pointer.x <= this.x + this.sliderX + this.sliderLength && pointer.x >= this.x + this.sliderX){
                this.value = ( (pointer.x - this.x - this.sliderX) /this.sliderLength);
            }
        });

        this.onChange = ()=>{};

        this.value = 0.5;

        this.add([this.label,this.sliderLine,this.hover,this.sliderPoint]);

    }

    get value(){
        return parseFloat(<string>this._value);
    }

    set value(v){
        if(v < 0) v = 0;
        if(v > 1) v = 1;
        this._value = v;
        this.sliderPoint.x = (this.sliderLength * v) - this.dotSize/2;
        this.onChange(v);
    }

    increment(){
        this.value += 0.1;
    }

    decrement(){
        this.value -= 0.1;
    }

}